import FJText from './FJText.js';

class FJTextContent {
    constructor() {
        this._textList = [];
        this._paragraphList = [];
        this._lineBreakMaps = []; // 换行符和段落的绑定关系
    }

    addText(text) {
        this._textList.push(text);
    }

    clear() {
        this._textList.forEach(textGraph => {
            textGraph.destroy();
        });
        this._textList = [];
    }

    getAllTextList() {
        return this._textList;
    }
    selectIndex(index) {
        this._textList.forEach((textGraph, i) => {
            textGraph.isSelected = i === index;
        });
    }

    selectAtPoint(point) {
        let isFindSelect = false;
        this._textList.forEach(textGraph => {
            if (isFindSelect) textGraph.isSelected = false;
            else {
                const isSelected = textGraph.isInPoint(point);
                textGraph.isSelected = isSelected;
                if (isSelected) isFindSelect = true;
            }
        });
    }

    selectIndexToPoint(fromIndex, point) {
        let toIndex = -1;
        for (let i = 0; i < this._textList.length; i++) {
            const textGraph = this._textList[i];
            if (textGraph.isInPoint(point)) {
                toIndex = i;
                break;
            }
        }
        if (toIndex !== -1) {
            const fIndex = Math.min(fromIndex, toIndex);
            const tIndex = Math.max(fromIndex, toIndex);
            this._textList.forEach((textGraph, index) => {
                const isSelected = index >= fIndex && index <= tIndex;
                textGraph.isSelected = isSelected;
            });
        }
    }
    selectFromIndexToIndex(fromIndex = 0, toIndex) {
        const tIndex = Math.min(toIndex, this._textList.length - 1);
        for (let i = 0; i < this._textList.length; i++) {
            const textGraph = this._textList[i];
            textGraph.isSelected = i >= fromIndex && i <= tIndex;
        }
    }

    selectLine() {
        const selectedTexts = this.getSelectedTextList();
        for (let i = 0; i < this._paragraphList.length; i++) {
            const line = this._paragraphList[i];
            const find = line.find(textGraph => selectedTexts.indexOf(textGraph) !== -1);
            if (find) {
                line.forEach(textGraph => {
                    textGraph.isSelected = true;
                });
                break;
            }
        }
    }

    deSelectAll() {
        this._textList.forEach(textGraph => {
            if (textGraph.isSelected) {
                textGraph.isSelected = false;
            }
        });
    }

    getSelectedTextList() {
        const selectedTextList = [];
        this._textList.forEach(textGraph => {
            if (textGraph.isSelected) {
                selectedTextList.push(textGraph);
            }
        });
        return selectedTextList;
    }

    matchToText(text) {
        const matchTextList = text ? text.split(' ') : [];
        this._textList.forEach(textGraph => {
            textGraph.isSelected = false;
            textGraph.isMatch = matchTextList.findIndex(matchText => textGraph.isMatchText(matchText)) !== -1;
        });
    }

    getMatchTextList() {
        const matchTextList = [];
        this._textList.forEach(textGraph => {
            if (textGraph.isMatch) {
                matchTextList.push(textGraph);
            }
        });
        return matchTextList;
    }

    getDeleteTextList() {
        const deleteTextList = [];
        this._textList.forEach(textGraph => {
            if (textGraph.isDelete) {
                deleteTextList.push(textGraph);
            }
        });
        return deleteTextList;
    }

    indexOfTextGraph(graph) {
        return this._textList.findIndex(item => item === graph);
    }

    renderContent(content, isHideDelete) {
        content.innerHTML = '';
        this._paragraphList = [];
        this._lineBreakMaps = [];
        let paragraph = [];
        this._textList.forEach((textGraph, index) => {
            // 显示或隐藏被删除的文字
            textGraph.isHide = textGraph.isDelete ? isHideDelete : false;
            textGraph.render(content);
            paragraph.push(textGraph);
            if (textGraph.isParagraphEnd()) {
                const isAllHide = paragraph.every(textGraph => textGraph.isHide);
                this._paragraphList.push(paragraph);

                // 如果是最后一个字，则不加换行
                // 如果是倒数第2个字，且最后一个是空字，则也不加换行
                // 添加换行
                const isLast = index === this._textList.length - 1;
                const isSecondAndEmpty =
                    index === this._textList.length - 2 && this._textList[this._textList.length - 1].isEmpty();

                if (!isLast && !isSecondAndEmpty && !isAllHide) {
                    const p = document.createElement('p');
                    p.innerHTML = 'p';
                    p.style.opacity = 0;
                    content.appendChild(p); // 添加换行
                    this._lineBreakMaps.push({
                        paragraph: paragraph,
                        line: p,
                    });
                }
                paragraph = [];
            }
        });
    }

    renderStyle() {
        this._textList.forEach(textGraph => {
            textGraph.renderStyle();
        });
    }
    // 更新换行，避免出现多个换行在一起的情况。当文字被删除后且不显示时，有可能导致换行符连在一起。当对应的整行文字都被删除时，对应的换行符才应该被删除
    updateLineBreak() {
        this._lineBreakMaps.forEach(data => {
            const { paragraph, line } = data;
            const isAllHide = paragraph.every(textGraph => textGraph.isHide);
            if (isAllHide) {
                if (line && line.parentNode) line.parentNode.removeChild(line);
            }
        });
    }

    encode(json) {
        if (!json.textList) return;
        json.textList.forEach(data => {
            const textGraph = new FJText({});
            textGraph.fromJson(data);
            this.addText(textGraph);
        });
    }

    fromJson(json) {
        const data = JSON.parse(json);
        const textDataList = data.textList;
        if (textDataList.length !== this._textList.length) return;

        this._textList.forEach((text, index) => {
            text.fromJson(textDataList[index]);
        });
    }

    toJson() {
        return JSON.stringify({
            textList: this._textList.map(text => text.toJson()),
        });
    }
}

const textContent = new FJTextContent();
export default textContent;
